var map = {
	"./averta-bold.otf": 427,
	"./averta-extrathin.otf": 3239,
	"./averta-light.otf": 2596,
	"./averta-regular.otf": 9388,
	"./averta-regularitalic.otf": 6324,
	"./averta-semibold.otf": 869,
	"./averta-thin.otf": 9939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1549;